import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { CURRENT_PTWAVE_VERSION, PAPER_PTWAVE_VERSION } from '../../version';
import './About.css';

function About() {
    const [markdownContent, setMarkdownContent] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchMarkdown = async () => {
            try {
                const response = await fetch('/markdown/ptwave_manual.md');
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const text = await response.text();
                setMarkdownContent(text);
            } catch (err) {
                console.error("Failed to fetch markdown content:", err);
                setError("Failed to load content. Please try again later.");
            } finally {
                setLoading(false);
            }
        };

        fetchMarkdown();
    }, []);

    if (loading) {
        return <p>Loading manual...</p>;
    }

    if (error) {
        return <p className="error">{error}</p>;
    }

    return (
        <div className="about-section">
            <aside className="about-version-notice" aria-label="Version information">
                <strong>Version information</strong>
                <span>
                    This website runs PtWAVE {CURRENT_PTWAVE_VERSION}. The version described in the published paper is PtWAVE {PAPER_PTWAVE_VERSION}.
                </span>
            </aside>
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[rehypeRaw]} // ここに rehypeRaw を追加
                // HTMLタグをそのままレンダリングするため、divのカスタムコンポーネントは不要になる場合があります。
                // ただし、もし `a` タグを非表示にしたい場合は、依然として `components.a` のカスタマイズが必要です。
                // components={{
                //     a: CustomLink, // ページ内リンクのテキストを非表示にする必要がある場合
                // }}
            >
                {markdownContent}
            </ReactMarkdown>
        </div>
    );
}

export default About;
